import { HistoryList } from '../history'
import { Header } from '../header'
import { Version } from '../version'

const History = () => {
  return (
    <div className='container mx-0 min-w-full min-h-full flex flex-col mt-[1px] select-none'>
      <Header title='History' withLogo />
      <HistoryList />
      <Version />
    </div>
  )
}

export { History }
